module.exports = __webpack_public_path__ + "static/reactjs-be874c75abdee70377d4f152b94b8d8e.png";